<template>
  <div class='activity'>
    <div class="activity-swiper">
      <el-carousel
        trigger="click"
        :interval="6000"
        arrow="hover"
      >
        <el-carousel-item v-for="(item, index) in swpierList" :key="index">
          <div class="swiper-box">
            <div v-if="index == 0" class="oneSwiper">
              <img class="image" :src="item.img" alt="" srcset="" />
              <img class="signup-btn" src="../../../assets/serve/designer/signup.png" @click="gosignup"/>
            </div>
            <a v-else :href="item.url" target="_blank">
              <img class="image" :src="item.img" alt="" srcset="" />
            </a>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="banner">
      
    </div>
    <div class="container">
      <template v-for="(item, index) in list">
        <div class="box" :key="index" @click="showDialog(item)">
          <img class="image" :src="JSON.parse(item.photos)[0].pic_url" alt="">
          <div class="name">{{item.comment}}</div>
        </div>
      </template>
    </div>
    <ActivityInfo v-if="showPopup" :show="showPopup" :info="info" @close="showPopup = false"></ActivityInfo>
    <ActivitySignup v-if="showActivitySignup" :show="showActivitySignup" :userInfo="userInfo" @close="showActivitySignup = false" @success="showSuccess = true"></ActivitySignup>
    <SignupSuccess v-if="showSuccess" :show="showSuccess" showbtn @close="showSuccess = false"></SignupSuccess>
  </div>
</template>

<script>
import { searchCase } from '@/api/case.js'
import ActivitySignup from "@/components/activitySignup.vue"
import ActivityInfo from '@/components/activityInfo.vue'
import SignupSuccess from '@/components/signupSuccess.vue'

export default {
  name: 'activity',
  components:{ 
    ActivitySignup,
    ActivityInfo,
    SignupSuccess
  },
  props: {
    userInfo: {}
  },
  data() {
    return {
      form: {
        chk_type: 1,
        pageSize: 30,
        pageNum: 1
      },
      list: [],
      info: '',
      showPopup: false,
      showActivitySignup: false,
      showSuccess: false,
      swpierList: [
        {
          img: require('../../../assets/serve/activity/bg.png'),
          url: ''
        },
        {
          img: require('@/assets/serve/index1.png'),
          url: 'https://mp.weixin.qq.com/s?__biz=MzkyMDA1MzAzOQ==&mid=2247495663&idx=1&sn=6836062717dcb4dadb6fe6510bc5e5e7&chksm=c19a1baff6ed92b9fc07b7a71a05fa799acd33d8c9a2b89a7ae3bfb4cf48c3e2be47e95362da&token=1941848510&lang=zh_CN#rd'
        }
      ]
    }
  },
  computed:{ },
  watch:{ },
  created() {
    this.getList()
  },
  mounted() {
      
  },
  methods: {
    getList() {
      searchCase({...this.form}).then(res => {
        this.list = res.data
      })
    },
    showDialog(data) {
      this.info = data
      this.showPopup = true
    },
    closeDialog() {
      this.showPopup = false
    },
    gosignup() {
      if ('id' in this.userInfo) {
        this.showActivitySignup = true
      } else {
        this.$emit('needLogin', true)
      }
    }
  }
}
</script>
<style lang='less' scoped>
.activity {
  max-width: 1920px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  background: #DEDEDE;
  .banner {
    position: relative;
    .kv {
      width: 100%;
    }
  }
  .container {
    width: 1664px;
    /* 列间距 */
    column-count:4;
    column-gap: 50px;
    padding: 20px 0 60px 0;
    margin: 0 auto;
    .box {
      width: 392px;
      height: auto;
      break-inside: avoid;
      margin: 0 32px 32px 0;
      cursor: pointer;
      &:nth-of-type(2n) {
        .image {
          height: 400px;
        }
      }
      &:nth-of-type(4n) {
        .image {
          height: 100px;
        }
      }
      &:nth-of-type(5n) {
        .image {
          height: 600px;
        }
      }
      .image {
        width: 100%;
        vertical-align: top;
        display: block;
      }
      .name {
        background: #fff;
        font-size: 26px;
        font-family: PingFangSC;
        font-weight: 400;
        color: #000000;
        padding: 31px; 
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  .activity-swiper {
    width: 100%;
    max-width: 1920px;
    max-height: 585px;
    margin: 0 auto;
    .swiper-box {
      width: 100%;
      height: 100%;
      max-width: 1920px;
      max-height: 585px;
      position: relative;
      .oneSwiper {
        position: absolute;
        left:0;
        top: 0;
        .signup-btn {
          width: 262px;
          height: 80px;
          position: absolute;
          bottom: 110.5px;
          left: 50%;
          transform: translateX(-50%);
          cursor: pointer;
        }
      }
      img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
        object-fit: cover;
      }
      .scale {
        animation: imageScale 2s forwards;
      }
      .content {
        width: 100%;
        text-align: center;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title {
          font-size: 48px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 25px;
          margin-bottom: 32px;
        }
        .descr {
          font-size: 28px;
          color: #FFFFFF;
          line-height: 36px;
          margin: 0 auto;
          p {
            margin: 0;
          }
        }
      }
      // .content.textAnimated {
      //   // animation: textFadeupin  1.6s forwards;
      // }
    }
    /deep/ .el-carousel__container {
      height: 585px;
      max-height: 585px;
    }
    /deep/ .el-carousel__indicators {
      bottom: 37px;
    }
    /deep/ .el-carousel__button {
      width: 68px;
      height: 8px;
      background: #fff;
      display: none;
    }
    // /deep/ .el-carousel__indicator.is-active {
    //   .el-carousel__button{
    //     background: #009538
    //   }
    // }
  }
}
</style>